import { WidgetType } from 'types/widget.types';
import { generateDefaultData as generateTextData } from 'widgets/TextBasedWidgets/TextWidget/TextWidget.helpers';

import { DEFAULT_WIDGET_DIMENSIONS } from './MultipleChoicesWidget.config';
import {
  ComponentWidgetIdKeys as MultipleChoicesComponentKey,
  MultipleChoicesType,
} from './MultipleChoicesWidget.types';
import { VERSION } from './MultipleChoicesWidget.upgrade';

/**
 * Return the default multiple-choice widget data has the question and answers as group members
 * @param type {MultipleChoicesType}
 * @param questionText {string} Qeustion TextWidget text value
 * @param defaultAnswerTexts {string[]} Answers TextWidget text value
 * @returns
 */
const generateDefaultData = (
  type: MultipleChoicesType,
  questionText: string = '',
  defaultAnswerTexts: string[] = [],
  correctAnswers: string[] = [],
) => {
  const { widthPx, heightPx } = DEFAULT_WIDGET_DIMENSIONS;
  const defaultWidgetData = {
    version: VERSION,
    widgetType: WidgetType.MultipleChoices,
    widgetData: {
      widthPx,
      heightPx,
      topPx: 200,
      leftPx: 200,
      rotateDeg: 0,
      version: VERSION,

      memberWidgetIds: [],
      componentWidgetIdMap: {},

      altText: '',
      isDecorative: true,
      // MultipleChoices layout type
      type,
      correctAnswers: correctAnswers,
      selectedAnswers: [],
    },
    groupWidgets: [
      {
        ...generateTextData('paragraph', questionText),
        componentKey: MultipleChoicesComponentKey.QuestionText,
      },
    ],
    isResponsiveGroup: true,
  };

  // Add default answer text widgets
  for (let i = 0; i < defaultAnswerTexts.length; i++) {
    defaultWidgetData.groupWidgets.push({
      ...generateTextData('paragraph', defaultAnswerTexts[i]),
      componentKey: MultipleChoicesComponentKey.AnswerText,
    });
  }

  return defaultWidgetData;
};

/**
 * Return the default multiple-choice widget data for use in element menus
 * @param type {MultipleChoicesType}
 * @returns
 */
const generateDefaultMenuData = (type: MultipleChoicesType) => {
  const widgetData = generateDefaultData(type, 'Q- The chemical symbol for gold is "Au"', ['True', 'False'], ['0']);
  const { widthPx, heightPx } = DEFAULT_WIDGET_DIMENSIONS;
  widgetData.widgetData = {
    ...widgetData.widgetData,
    widthPx,
    heightPx,
  };

  return widgetData;
};

export { generateDefaultData, generateDefaultMenuData };
